import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetOne } from 'redux/actions/deaths.actions';

import LayoutContainer from 'containers/LayoutContainer';
import DeathsShow from 'views/public/DeathsView/components/DeathsShow';

import Loading from 'components/commons/Loading';

import 'views/public/DeathsView/components/DeathsShow/i18n';

const DeathsShowContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const { loading, selectedItem: item } = useTypedSelector((state) => state.deaths);

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <DeathsShow item={item} />
      {loading && <Loading isModalMode message={i18next.t('DEATHS_SHOW:LOADING')} />}
    </LayoutContainer>
  );
};

export default DeathsShowContainer;
